import { AUDIT } from "../constants";
import { instance } from "../../axios";

// Only the latest search is shown: when the filters change quickly, an older
// answer arriving late must not overwrite a newer one
let latestRequest = 0;

// filters: { table, operation, q }; empty values are left out
const getAuditAction = (limit, offset, filters = {}) => {
  return (dispatch) => {
    const request = ++latestRequest;
    dispatch({ type: AUDIT.GET_AUDIT });
    const params = new URLSearchParams({ limit, offset });
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
    instance
      .get(`/audit?${params.toString()}`)
      .then((results) => {
        if (request !== latestRequest) return;
        dispatch({ type: AUDIT.GET_AUDIT_SUCCESS, payload: results.data });
      })
      .catch((error) => {
        if (request !== latestRequest) return;
        dispatch({ type: AUDIT.GET_AUDIT_FAILURE, payload: error });
      });
  };
};

export { getAuditAction };
